import Power from './power'
import Clickoutside from './clickoutside'

const install = (Vue) => {
  Vue.directive('power', Power)   // 二次冥函数
  Vue.directive('clickoutside', Clickoutside)
}
export default install



// WEBPACK FOOTER //
// ./src/instruction/index.js